export default "/assets/site/images/fittness.jpg?a461725d0b8bd6e1dc412d82fa9372ac";